// 7스텝 슬라이드 설문 폼 (비디오 상단 공통 + 스텝별 이미지 오버레이)
// 스텝1: 치아교정을 정말 하고 싶다? (O, X)
// 스텝2: 교정이 필요한 이유는? (돌출입 / 덧니 / 부정교합 / 기타)
// 스텝3: 교정 치과 선택 시 고려대상은? (비용 / 위치 / 의사 경력 / 병원 크기)
// 스텝4: 대상자의 성별은 무엇인가요? (남자/여자)
// 스텝5: 대상자의 성함 입력
// 스텝6: 대상자의 휴대폰 번호 입력
// 스텝7: 개인정보 동의 및 제출

import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { prohibitedWords } from "../utils/dummyData";

import "./randingStyle30.scss";
import PrivacyContent from "./PrivacyContent";
import { buildPrivacyNewFormHtml } from "./privacyNewForm";
import MarketingContent from "./MarketingContent";

function RandingStyle30({
  urlCode,
  urlCodeSettingId,
  videoSrc,
  stepImageBasePath,
  companyName,
  footerPath,
  apiUrl,
  privacyMessage,
  kakaotalk,
  carrotTag,
  customFooter,
  footerData,
  footerStyle,
  topImg,
  callIconImg,
  callNumber,
  hideFooter,
  privacyCompanyName,
  privacyNewForm,
  privacyTrustee,
  legacyMarketing = false,
  footerText,
  footerLegalColor,
  stepImageUrls,
  smoothTransition = false,
}) {
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [selectedWant, setSelectedWant] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedConsider, setSelectedConsider] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({ first: "010", second: "", third: "" });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isMarketingAgreed, setIsMarketingAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [isMarketingModal, setIsMarketingModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  const phoneSecondRef = useRef(null);
  const phoneThirdRef = useRef(null);

  const validateInput = () =>
    validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber);

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
    setIsMarketingModal(false);
  };

  const toggleMarketingModal = () => {
    setIsMarketingModal(!isMarketingModal);
    setIsPrivacyPolicyModal(false);
  };

  const handleAllAgree = () => {
    const newValue = !(isAgreed && isMarketingAgreed);
    setIsAgreed(newValue);
    setIsMarketingAgreed(newValue);
  };

  const handleChoice = (setter, value) => {
    setter(value);
    setCurrentStep((prev) => prev + 1);
  };

  const handleNextStep5 = () => {
    if (!name.trim()) {
      alert("이름을 입력해주세요.");
      return;
    }
    setCurrentStep(6);
  };

  const handleNextStep6 = () => {
    const fullPhone = `${phoneNumber.first}${phoneNumber.second}${phoneNumber.third}`;
    if (fullPhone.length < 10) {
      alert("연락처를 정확히 입력해주세요.");
      return;
    }
    setCurrentStep(7);
  };

  const handleSubmit = () => {
    const selectedOption = [selectedWant, selectedReason, selectedConsider, selectedGender]
      .filter(Boolean)
      .join(" / ");

    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,
      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  const displayNumber = callNumber || "0507-1381-8528";
  const telNumber = displayNumber.replace(/-/g, "");

  const handleCallClick = () => {
    if (urlCodeSettingId) {
      fetch(
        `https://funnelsolution.co.kr/api/urlcode/request-count/${encodeURIComponent(urlCodeSettingId)}`,
        { method: "POST", headers: { "Content-Type": "application/json" } }
      )
        .then(() => console.log("[511] 전화 클릭 - request count 증가 완료"))
        .catch((err) => console.error("[511] request count 증가 실패:", err));
    }
  };

  const stepImgSrc = (stepNum) =>
    stepImageUrls ? stepImageUrls[stepNum - 1] : `${stepImageBasePath}/3-${stepNum}.jpg`;

  useEffect(() => {
    if (!smoothTransition) return;
    for (let i = 1; i <= 7; i++) {
      const img = new Image();
      img.src = stepImgSrc(i);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [smoothTransition]);

  const stepImg = (stepNum) => (
    <div className="step-image-wrapper">
      <img
        src={stepImgSrc(stepNum)}
        alt={`치아교정 상담 ${stepNum}단계`}
        {...(smoothTransition ? { decoding: "sync" } : {})}
      />
    </div>
  );

  return (
    <div className={`form-container randing-style-30${smoothTransition ? " smooth" : ""}`}>

      {/* smooth 모드: 전 스텝 이미지를 항상 마운트해 디코드 상태 유지 (레이아웃 영향 없음) */}
      {smoothTransition && (
        <div className="step-preload" aria-hidden="true">
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <img key={i} src={stepImgSrc(i)} alt="" />
          ))}
        </div>
      )}

      {/* 상단 인콜 버튼 */}
      {topImg && (
        <div className="top-call-wrapper">
          <div style={{ position: "relative", width: "100%" }}>
            <img src={topImg} alt="상단 이미지" style={{ width: "100%", display: "block" }} />
            {callIconImg && (
              <a href={`tel:${telNumber}`} className="call-button" onClick={handleCallClick}>
                <img src={callIconImg} alt="전화하기" />
              </a>
            )}
          </div>
        </div>
      )}

      {/* 공통 비디오 */}
      {videoSrc && (
        <div className="step-video-wrapper">
          <video
            autoPlay
            muted
            playsInline
            loop
            ref={(el) => {
              if (el) el.muted = true;
            }}
          >
            <source src={videoSrc} type="video/mp4" />
          </video>
        </div>
      )}

      {/* 스텝 1 - 교정 의향 */}
      {currentStep === 1 && (
        <div className="step step1">
          <div className="step-content">
            <div className="select-buttons">
              {["O", "X"].map((option) => (
                <button
                  key={option}
                  className={`select-btn ${selectedWant === option ? "selected" : ""}`}
                  onClick={() => handleChoice(setSelectedWant, option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
          {stepImg(1)}
        </div>
      )}

      {/* 스텝 2 - 교정이 필요한 이유 */}
      {currentStep === 2 && (
        <div className="step step2">
          <div className="step-content">
            <div className="select-buttons grid-layout">
              {["돌출입", "덧니", "부정교합", "기타"].map((option) => (
                <button
                  key={option}
                  className={`select-btn ${selectedReason === option ? "selected" : ""}`}
                  onClick={() => handleChoice(setSelectedReason, option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
          {stepImg(2)}
        </div>
      )}

      {/* 스텝 3 - 교정 치과 선택 시 고려대상 */}
      {currentStep === 3 && (
        <div className="step step3">
          <div className="step-content">
            <div className="select-buttons grid-layout">
              {["비용", "위치", "의사 경력", "병원 크기"].map((option) => (
                <button
                  key={option}
                  className={`select-btn ${selectedConsider === option ? "selected" : ""}`}
                  onClick={() => handleChoice(setSelectedConsider, option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
          {stepImg(3)}
        </div>
      )}

      {/* 스텝 4 - 성별 */}
      {currentStep === 4 && (
        <div className="step step4">
          <div className="step-content">
            <div className="select-buttons">
              {["남자", "여자"].map((option) => (
                <button
                  key={option}
                  className={`select-btn ${selectedGender === option ? "selected" : ""}`}
                  onClick={() => handleChoice(setSelectedGender, option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
          {stepImg(4)}
        </div>
      )}

      {/* 스텝 5 - 이름 입력 */}
      {currentStep === 5 && (
        <div className="step step5">
          <div className="step-content">
            <div className="input-form">
              <div className="input-field">
                <input
                  type="text"
                  placeholder="이름"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <button className="continue-btn" onClick={handleNextStep5}>
                계속하기
              </button>
            </div>
          </div>
          {stepImg(5)}
        </div>
      )}

      {/* 스텝 6 - 휴대폰 번호 입력 */}
      {currentStep === 6 && (
        <div className="step step6">
          <div className="step-content">
            <div className="input-form">
              <div className="input-field phone-field">
                <input
                  type="tel"
                  placeholder="010"
                  maxLength="3"
                  value="010"
                  readOnly
                />
                <input
                  ref={phoneSecondRef}
                  type="tel"
                  placeholder="0000"
                  maxLength="4"
                  value={phoneNumber.second}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
                    setPhoneNumber((prev) => ({ ...prev, first: "010", second: val }));
                    if (val.length === 4) phoneThirdRef.current?.focus();
                  }}
                />
                <input
                  ref={phoneThirdRef}
                  type="tel"
                  placeholder="0000"
                  maxLength="7"
                  value={phoneNumber.third}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 7);
                    setPhoneNumber((prev) => ({ ...prev, first: "010", third: val }));
                  }}
                />
              </div>
              <button className="continue-btn" onClick={handleNextStep6}>
                계속하기
              </button>
            </div>
          </div>
          {stepImg(6)}
        </div>
      )}

      {/* 스텝 7 - 개인정보 동의 및 제출 */}
      {currentStep === 7 && (
        <div className="step step7">
          <div className="step-content">
            <div className="agreement-section">
              <div className="agree-item all-agree">
                <input
                  type="checkbox"
                  id="allAgree"
                  checked={isAgreed && isMarketingAgreed}
                  onChange={handleAllAgree}
                />
                <label htmlFor="allAgree">전체 동의</label>
              </div>

              <div className="agree-item-wrapper">
                <div className="agree-item">
                  <input
                    type="checkbox"
                    id="privacyPolicyAgree"
                    checked={isAgreed}
                    onChange={() => setIsAgreed(!isAgreed)}
                  />
                  <label htmlFor="privacyPolicyAgree">상담/예약 서비스 제공 동의 (필수)</label>
                  <span className="detail-link" onClick={togglePrivacyPolicyModal}>
                    ({isPrivacyPolicyModal ? "닫기" : "자세히보기"})
                  </span>
                </div>
                <div className={`toggle-content ${isPrivacyPolicyModal ? "open" : ""}`}>
                  <div className={`toggle-content-inner${privacyNewForm ? " privacy-new" : ""}`}>
                    {privacyNewForm ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: buildPrivacyNewFormHtml({
                            hospital: privacyCompanyName || companyName || "수집주체명",
                            trustee: privacyTrustee,
                          }),
                        }}
                      />
                    ) : (
                      <PrivacyContent companyName={privacyCompanyName || companyName || "수집주체명"} />
                    )}
                  </div>
                </div>
              </div>

              <div className="agree-item-wrapper">
                <div className="agree-item">
                  <input
                    type="checkbox"
                    id="marketingAgree"
                    checked={isMarketingAgreed}
                    onChange={() => setIsMarketingAgreed(!isMarketingAgreed)}
                  />
                  <label htmlFor="marketingAgree">마케팅 정보 수신 (선택)</label>
                  <span className="detail-link" onClick={toggleMarketingModal}>
                    ({isMarketingModal ? "닫기" : "자세히보기"})
                  </span>
                </div>
                <div className={`toggle-content ${isMarketingModal ? "open" : ""}`}>
                  <div className="toggle-content-inner">
                    <MarketingContent companyName={privacyCompanyName || companyName || "수집주체명"} legacy={legacyMarketing} />
                  </div>
                </div>
              </div>

              <p className="benefitInfo">
                ※ 상담/예약 서비스 제공 동의는 필수 항목입니다.
                <br />
                ※ 마케팅 정보 수신은 선택 항목이며, 동의하지 않아도 신청할 수 있습니다.
              </p>

              <button className="submit-btn" onClick={handleSubmit} disabled={isSubmitting}>
                설문제출완료
              </button>
            </div>
          </div>
          {stepImg(7)}
        </div>
      )}

      {!hideFooter && <div className="footer" style={footerStyle}>
        {customFooter && footerData ? (
          <div className="custom-footer">
            <p className="footer-line1">{footerData.line1}</p>
            <p className="footer-line2">{footerData.line2}</p>
            <p className="footer-line3">{footerData.line3}</p>
          </div>
        ) : (
          footerPath && <img src={footerPath} alt="푸터" />
        )}
      </div>}

      {footerText && (
        <footer className="rs30-footer">
          {footerLegalColor
            ? footerText.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {i > 0 && "\n"}
                  {/^(Copyright|사업자등록번호)/.test(line) ? (
                    <span style={{ color: footerLegalColor }}>{line}</span>
                  ) : (
                    line
                  )}
                </React.Fragment>
              ))
            : footerText}
        </footer>
      )}
    </div>
  );
}

export default RandingStyle30;
